module.exports = __webpack_public_path__ + "img/RaspberryPi.fdf4fda6.png";